/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Notification_Agent_Run_ApprovalInputs */



/**
* | output |
* | --- |
* | "{name} is waiting for your approval" |
*
* @param {Notification_Agent_Run_ApprovalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notification_agent_run_approval = /** @type {((inputs: Notification_Agent_Run_ApprovalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Agent_Run_ApprovalInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} wartet auf Ihre Freigabe.`)
	return /** @type {LocalizedString} */ (`${i?.name} is waiting for your approval`)
});